import { useState, useEffect } from "react";

function LazyImage({ src, alt, className, placeholder, style, isVisible }) {
    const [isLoaded, setIsLoaded] = useState(false);
    const [imageSrc, setImageSrc] = useState(placeholder); // Start with placeholder

    useEffect(() => {
        if (isVisible && src) {
            setImageSrc(src); // Update to actual image
        }
    }, [isVisible, src]);

    const handleLoad = () => {
      
        setIsLoaded(true);
    };

    return (
        <div className={`card-image-wrapper ${className}`} style={{ position: "absolute", width: "100%", height: "100%", ...style }}>
            {/* The actual image */}
            <img
                src={imageSrc}
                alt={alt}
                className={`card-image ${className}`} // 🔥 Ensures className is inherited
                onLoad={handleLoad} // Ensure smooth transition
                style={{
                    opacity: isLoaded ? 1 : 0, // Smooth fade-in effect
                    transition: "opacity 0.5s ease-in-out",
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                 
                    position: "absolute",
                    backfaceVisibility: "hidden", // 🔥 Ensures proper flipping
                    ...style,
                }}
            />

            {/* Blurry Placeholder While Loading */}
            {!isLoaded && (
                <img
                    src={placeholder}
                    alt="Loading"
                    className={`card-image ${className}`}
                    style={{
                        position: "absolute",
                        filter: "blur(10px)",
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        transition: "opacity 0.3s ease-in-out",
                        backfaceVisibility: "hidden", // 🔥 Keeps correct rendering
                        ...style,
                    }}
                />
            )}
        </div>
    );
}

export default LazyImage;
